import r from"./_baseIsTypedArray.js";import a from"./_baseUnary.js";import o from"./_nodeUtil.js";var s=o&&o.isTypedArray,e=s?a(s):r;export{e as default};
//# sourceMappingURL=isTypedArray.js.map
